import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "@/context/AuthContext";
import MarketingNav from "@/components/marketing/MarketingNav";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import LaunchWaitlistModal from "@/components/marketing/LaunchWaitlistModal";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const location = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name.split(" ")[0]}.`);
      const to = location.state?.from || (user.onboarding_completed ? "/app" : "/onboarding");
      nav(to, { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F9FC]">
      <MarketingNav />
      <div className="pt-28 pb-16 px-6 lg:px-10 flex justify-center">
        <div className="w-full max-w-md" data-testid="login-page">
          <p className="text-xs uppercase tracking-[0.2em] text-[#2C6BAC] font-semibold mb-3">Welcome back</p>
          <h1 className="font-display text-4xl tracking-tighter text-[#1A1A2E] mb-8">
            Log in to WYLO.
          </h1>

          <form onSubmit={submit} className="space-y-5 bg-white border border-[#E8ECF2] rounded-xl p-7" aria-hidden="true">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" autoComplete="email" disabled tabIndex={-1} />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" autoComplete="current-password" disabled tabIndex={-1} />
            </div>
            {error && (
              <div
                role="alert"
                className="rounded-md border border-[#E24B4A]/40 bg-[#E24B4A]/10 text-[#E24B4A] text-sm px-3 py-2"
                data-testid="login-error"
              >
                {error}
              </div>
            )}
            <Button disabled className="w-full bg-[#2C6BAC] hover:bg-[#1A3A5C] text-white" data-testid="login-submit" tabIndex={-1}>
              Log in
            </Button>

            <div className="flex items-center justify-between text-sm">
              <span className="text-[#555568]">Available at launch</span>
              <Link to="/register" className="text-[#2C6BAC] hover:underline">Create account</Link>
            </div>
          </form>
        </div>
      </div>

      <LaunchWaitlistModal />
    </div>
  );
}
